{
 "subtitle": {
  "x": 279,
  "y": 249,
  "w": 386,
  "h": 26
 },
 "name": {
  "x": 260,
  "y": 324,
  "w": 144,
  "h": 23
 },
 "avatarText": {
  "x": 169,
  "y": 407,
  "w": 336,
  "h": 35
 },
 "required": {
  "x": 622,
  "y": 1160,
  "w": 207,
  "h": 17
 },
 "gender": {
  "x": 146,
  "y": 1215,
  "w": 77,
  "h": 20
 },
 "band": {
  "x": 146,
  "y": 1329,
  "w": 111,
  "h": 24
 },
 "chips": {
  "filter": [
   {
    "k": "female",
    "lane": {
     "x": 108,
     "y": 450,
     "w": 240,
     "h": 70
    },
    "on": {
     "id": "chip.filter.female.on",
     "x": 108,
     "y": 450,
     "w": 240,
     "h": 70
    },
    "label": {
     "x": 220,
     "y": 475,
     "w": 67,
     "h": 18
    }
   },
   {
    "k": "male",
    "lane": {
     "x": 353,
     "y": 450,
     "w": 224,
     "h": 70
    },
    "on": {
     "id": "chip.filter.male.on",
     "x": 353,
     "y": 450,
     "w": 224,
     "h": 70
    },
    "label": {
     "x": 464,
     "y": 476,
     "w": 45,
     "h": 17
    }
   },
   {
    "k": "neutral",
    "lane": {
     "x": 583,
     "y": 450,
     "w": 252,
     "h": 70
    },
    "on": {
     "id": "chip.filter.neutral.on",
     "x": 583,
     "y": 450,
     "w": 252,
     "h": 70
    },
    "label": {
     "x": 671,
     "y": 476,
     "w": 134,
     "h": 17
    }
   }
  ],
  "gender": [
   {
    "k": "woman",
    "lane": {
     "x": 98,
     "y": 1244,
     "w": 172,
     "h": 64
    },
    "on": {
     "id": "chip.gender.woman.on",
     "x": 98,
     "y": 1244,
     "w": 172,
     "h": 64
    },
    "label": {
     "x": 150,
     "y": 1266,
     "w": 67,
     "h": 18
    }
   },
   {
    "k": "man",
    "lane": {
     "x": 274,
     "y": 1244,
     "w": 136,
     "h": 64
    },
    "on": {
     "id": "chip.gender.man.on",
     "x": 274,
     "y": 1244,
     "w": 136,
     "h": 64
    },
    "label": {
     "x": 320,
     "y": 1266,
     "w": 44,
     "h": 18
    }
   },
   {
    "k": "nonbinary",
    "lane": {
     "x": 416,
     "y": 1244,
     "w": 208,
     "h": 64
    },
    "on": {
     "id": "chip.gender.nonbinary.on",
     "x": 416,
     "y": 1244,
     "w": 208,
     "h": 64
    },
    "label": {
     "x": 452,
     "y": 1266,
     "w": 134,
     "h": 17
    }
   },
   {
    "k": "unspecified",
    "lane": {
     "x": 628,
     "y": 1244,
     "w": 216,
     "h": 64
    },
    "on": {
     "id": "chip.gender.unspecified.on",
     "x": 628,
     "y": 1244,
     "w": 216,
     "h": 64
    },
    "label": {
     "x": 664,
     "y": 1267,
     "w": 148,
     "h": 21
    }
   }
  ],
  "band": [
   {
    "k": "16_17",
    "lane": {
     "x": 98,
     "y": 1358,
     "w": 144,
     "h": 64
    },
    "on": {
     "id": "chip.band.16_17.on",
     "x": 98,
     "y": 1358,
     "w": 144,
     "h": 64
    },
    "label": {
     "x": 142,
     "y": 1382,
     "w": 57,
     "h": 16
    }
   },
   {
    "k": "18_24",
    "lane": {
     "x": 244,
     "y": 1358,
     "w": 154,
     "h": 64
    },
    "on": {
     "id": "chip.band.18_24.on",
     "x": 244,
     "y": 1358,
     "w": 154,
     "h": 64
    },
    "label": {
     "x": 292,
     "y": 1381,
     "w": 59,
     "h": 17
    }
   },
   {
    "k": "25_34",
    "lane": {
     "x": 400,
     "y": 1358,
     "w": 154,
     "h": 64
    },
    "on": {
     "id": "chip.band.25_34.on",
     "x": 400,
     "y": 1358,
     "w": 154,
     "h": 64
    },
    "label": {
     "x": 448,
     "y": 1382,
     "w": 59,
     "h": 16
    }
   },
   {
    "k": "35_44",
    "lane": {
     "x": 556,
     "y": 1358,
     "w": 148,
     "h": 64
    },
    "on": {
     "id": "chip.band.35_44.on",
     "x": 556,
     "y": 1358,
     "w": 148,
     "h": 64
    },
    "label": {
     "x": 601,
     "y": 1382,
     "w": 59,
     "h": 16
    }
   },
   {
    "k": "45plus",
    "lane": {
     "x": 706,
     "y": 1358,
     "w": 138,
     "h": 64
    },
    "on": {
     "id": "chip.band.45plus.on",
     "x": 706,
     "y": 1358,
     "w": 138,
     "h": 64
    },
    "label": {
     "x": 759,
     "y": 1382,
     "w": 35,
     "h": 16
    }
   }
  ]
 },
 "frames": [
  {
   "col": 0,
   "tile": {
    "x": 115,
    "y": 522,
    "w": 236,
    "h": 191
   },
   "off": {
    "id": "frame.0",
    "x": 107,
    "y": 514,
    "w": 252,
    "h": 207
   },
   "on": {
    "id": "frame.0.on",
    "x": 108,
    "y": 514,
    "w": 248,
    "h": 207
   }
  },
  {
   "col": 1,
   "tile": {
    "x": 358,
    "y": 522,
    "w": 226,
    "h": 191
   },
   "off": {
    "id": "frame.1",
    "x": 350,
    "y": 514,
    "w": 242,
    "h": 207
   },
   "on": {
    "id": "frame.1.on",
    "x": 353,
    "y": 519,
    "w": 239,
    "h": 199
   }
  },
  {
   "col": 2,
   "tile": {
    "x": 593,
    "y": 522,
    "w": 232,
    "h": 191
   },
   "off": {
    "id": "frame.2",
    "x": 585,
    "y": 514,
    "w": 248,
    "h": 207
   },
   "on": {
    "id": "frame.2.on",
    "x": 585,
    "y": 519,
    "w": 245,
    "h": 199
   }
  }
 ]
}